import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { ChancenwerkUser } from './ChancenwerkUser.js';

export enum TemporaryUserType {
  // deprecated in favor of guest flag on user
  GuestLeKo = 'GuestLeKo',
}

// TODO löschen, wird nicht mehr genutzt
/**
 * @entity TemporaryUser
 * @deprecated Konzept wird nicht mehr genutzt
 */
@Entity()
export class TemporaryUser extends ChancenwerkUser {
  public static override _class = 'TemporaryUser';
  public static override readableName = 'Temporärer Benutzer';

  /**
   * Can be used to dynamically specify what type of temp. user this is,
   * for example a 'GuestLeKo'.
   */
  @Field(() => String)
  public type: Maybe<TemporaryUserType>;

  constructor(doc: PartialEntityData<TemporaryUser>) {
    super(doc);
  }
}
